import { useLazyQuery, useMutation } from '@apollo/client';
import React, { FC } from 'react';
import {
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1Document,
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderDocument,
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderDocument,
  FileInfo
} from '../../../../../../generated';
import { AuthResult, AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { FileUploadButtonWithGenerateIdFormButton } from './file-upload-with-generate-id-form-button';
import { GetIdCaseAuthHeader } from './id-case-get-auth-header';

interface FileUploadButtonWithGenerateIdFormButtonContainerProps {
  description?: string;
  caseId: string;
  title?: string;
  buttonText?: string;
  permittedContentTypes?: string[];
  permittedExtensions?: string[];
  isPreviewOnly?: boolean;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
  fileName: string;
  onUploadSuccess?: (response: AzureBlobResponse) => Promise<void>; // after upload and fetch preview data success
  isShowFileName?: boolean;
}

export const FileUploadButtonWithGenerateIdFormButtonContainer: FC<FileUploadButtonWithGenerateIdFormButtonContainerProps> = (props) => {
  // for upload file: start

  const [getAuthHeaderForPdfFile] = useMutation(
    CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderDocument
  );

  const [getAuthHeaderForImageFile] = useMutation(
    CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderDocument
  );

  const [getFilePreviewData] = useLazyQuery(CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1Document, {
    fetchPolicy: 'network-only'
  });

  const handleUpdateAfterUploadSuccess = async (uploadedData: AzureBlobResponse) => {
    props.onUploadSuccess?.(uploadedData);
  };

  const handleAuthorizeRequest = async (fileData: File, filename: string): Promise<AuthResult> => {
    return GetIdCaseAuthHeader(props.caseId, fileData, filename, getAuthHeaderForPdfFile, getAuthHeaderForImageFile);
  };

  const handleFetchFilePreviewData = async (filename: string): Promise<FileInfo> => {
    // const previewFileName = filename !== 'id-form.pdf' ? filename.replace('.pdf', '-preview.png') : filename;
    const previewData = await getFilePreviewData({
      variables: {
        identityVerificationCaseV1Id: props.caseId,
        fileName: filename
      }
    });
    return previewData?.data?.identityVerificationCaseV1?.fileByFileName as FileInfo;
  };
  // for upload file: end

  return (
    <FileUploadButtonWithGenerateIdFormButton
      title={props.title}
      caseId={props.caseId}
      buttonText={props.buttonText}
      description={props.description}
      permittedContentTypes={props.permittedContentTypes}
      permittedExtensions={props.permittedExtensions}
      isPreviewOnly={props.isPreviewOnly}
      setIsEditing={props.setIsEditing}
      onAuthorizeRequest={(fileData: File) => handleAuthorizeRequest(fileData, props.fileName)}
      fetchFilePreviewData={() => handleFetchFilePreviewData(props.fileName)}
      onUploadSuccess={(response) => handleUpdateAfterUploadSuccess(response)}
      isShowFileName={props.isShowFileName}
    />
  );
};

